import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { LoyaltyContentService } from "src/app/modules/registration/services/loyalty-content.service";
import { BookingContentService } from "src/app/services/bookingContentService/booking-content.service";
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss'],
  imports: [MatButtonModule]
})
export class SessionTimeoutComponent implements OnInit, OnDestroy {
    content: any;
    businessPointsContent: any;
  totalSeconds = 0;

  minutes = 0;
  seconds = 0;

  private intervalId: any;
  dictionaryContent:any;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly bookingContentService: BookingContentService,private readonly dictionaryContentService: DisctionaryContent, private readonly loyaltyContentService: LoyaltyContentService, private dialogRef: MatDialogRef<SessionTimeoutComponent>
  ) { }

  ngOnInit(): void {
    // The warning modal should strictly countdown 2 minutes (120 seconds) 
    // as per the UI text and the warning buffer, regardless of background token refresh.
    this.totalSeconds = 120;

    if (this.totalSeconds > 0) {
      this.minutes = Math.floor(this.totalSeconds / 60);
      this.seconds = this.totalSeconds % 60;
      this.startCountdown();
    } else {
      this.logoutNow();
    }
      this.loyaltyContentService.content$.subscribe((res: any) => { this.businessPointsContent = res; });
      this.bookingContentService.content$.subscribe((res: any) => { this.content = res; });
      this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => { this.dictionaryContent = res; });
  }

  startCountdown(): void {

    this.intervalId = setInterval(() => {

      this.totalSeconds--;

      this.minutes = Math.floor(this.totalSeconds / 60);
      this.seconds = this.totalSeconds % 60;

      if (this.totalSeconds <= 0) {
        this.logoutNow();
      }

    }, 1000);
  }

  stayLoggedIn(): void {
    this.dialogRef.close('continue');
  }

  logoutNow(): void {
    this.dialogRef.close('logout');
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}